module.exports = __webpack_public_path__ + "img/emailSvg.9f445f12.svg";